import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from "react";
import { LayoutCellById } from "./LayoutCellById";
import { SubconfigurationInstance } from "./SubconfigurationInstance";
import { SubconfigurationNavigationItemType, } from "./SubconfigurationNavigationProps";
/**
 * Renders current tab from child layout
 * @category UI
 * @param props
 * @returns
 */
export function SubconfigurationNavigationContent(props) {
    const { item, components } = props;
    if (!item) {
        return _jsx(Fragment, {});
    }
    if (item.type === SubconfigurationNavigationItemType.Group) {
        return _jsx(LayoutCellById, { layoutNodeId: item.layoutCellId });
    }
    // display all subconfiguration instances of the attribute
    return (_jsx(SubconfigurationNavigationAttributeContent, { item: item, components: components }));
}
function SubconfigurationNavigationAttributeContent(props) {
    const { item, components } = props;
    if (item == null) {
        throw new Error("Item is required in SubconfigurationNavigationAttributeContent");
    }
    // display a single instance
    if (item.type === SubconfigurationNavigationItemType.Instance) {
        return (_jsx(SubconfigurationInstance, { attribute: item.attribute, instancePath: item.path, components: components }));
    }
    if (item.type === SubconfigurationNavigationItemType.Attribute) {
        return _jsx(LayoutCellById, { layoutNodeId: item.layoutCellId });
    }
    // unknown type
    return _jsx(Fragment, {});
}
//# sourceMappingURL=SubconfigurationNavigationContent.js.map